import React from 'react'
import HelperText from './HelperText';

interface Props extends React.HTMLProps<HTMLTextAreaElement> {
    label?: string;
    resize?: "none" | "both" | "horizontal" | "vertical" | "block" | "inline";
    error?: boolean;
    helperText?: string;
    required?: boolean;
}

const StandardTextArea = (props: Props) => {
    const { error, helperText, ...rest } = props;

    function getColors() {
        if (props.disabled) {
            return `bg-utility-muted`;
        }
        if (error) {
            return `ring-red-400 ring-2 focus:ring-error`;
        }
        return `bg-neutral-deep text-primary-dark placeholder:text-neutral-dark focus:ring-primary-light focus:ring-2`;
    }

    return (
        <>
            <label className="block text-primary-dark font-bold text-[16px] mb-2">
                {props.label}{props.required && <span> *</span>}
            </label>
            <textarea
                className={`${getColors()} shadow-sm leading-normal w-full rounded-2xl py-[14.4px] px-4 text-[16px] font-bold box-border outline-none placeholder:font-medium`}
                style={{
                    resize: props.resize || "none",
                }}
                {...rest}
            />
            <HelperText error={error}>
                {helperText}
            </HelperText>
        </>
    )
}

export default StandardTextArea